import * as React from 'react'

import { cn } from '@/lib/utils'

function Input({
    className,
    type,
    onWheel,
    onKeyDown,
    ...props
}: React.ComponentProps<'input'>) {
    const isNumber = type === 'number'
    return (
        <input
            type={type}
            data-slot="input"
            className={cn(
                'border-input focus-visible:border-ring h-11 rounded-md border bg-transparent px-2.5 py-1 text-base shadow-xs transition-[color,box-shadow] md:h-9 md:text-sm placeholder:text-muted-foreground w-full min-w-0 outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            onWheel={(e) => {
                onWheel?.(e)
                // Lăn chuột khi ô number đang focus sẽ tăng/giảm giá trị theo
                // step (gây bug 10000 -> 9999.999). Blur để chuột chỉ cuộn trang.
                // Dùng blur thay preventDefault vì React đăng ký wheel là passive.
                if (isNumber && e.currentTarget === document.activeElement) {
                    e.currentTarget.blur()
                }
            }}
            onKeyDown={(e) => {
                onKeyDown?.(e)
                // Chặn phím ↑/↓ đổi giá trị theo step trên ô number.
                if (
                    isNumber &&
                    !e.defaultPrevented &&
                    (e.key === 'ArrowUp' || e.key === 'ArrowDown')
                ) {
                    e.preventDefault()
                }
            }}
            {...props}
        />
    )
}

export { Input }
